<template>
  <div class="doge-shell">
    <header class="doge-top"><button class="doge-back" @click="$router.back()">‹</button><h1 class="doge-title">{{ pageTitle }}</h1><div class="doge-placeholder"></div></header>
    <main class="doge-page-pad">
      <section v-for="item in notices" :key="item.id" class="notice-list-card" @click="openDetail(item)">
        <h2>{{ item.title || pageTitle }}</h2>
        <p v-if="previewText(item)">{{ previewText(item) }}</p>
        <time>时间：{{ formatTime(item.publishTime || item.created_at) }}</time>
      </section>
      <div v-if="loading" class="doge-empty">加载中...</div>
      <div v-else-if="!notices.length" class="doge-empty">暂无{{ pageTitle }}</div>
    </main>
    <BottomNav/>
  </div>
</template>
<script>
import BottomNav from '../../components/layout/BottomNav.vue';
export default {
  name: 'notices',
  components: { BottomNav },
  data() { return { notices: [], loading: false, categoryId: 0 }; },
  computed: {
    pageTitle() { return this.$route.query.title || this.$route.query.category || '公告'; },
    categoryName() { return this.$route.query.category || '公告'; },
    isAnnouncementPage() { return !this.$route.query.category || ['公告', 'Announcements'].includes(String(this.pageTitle).trim()) || ['公告', 'Announcements'].includes(String(this.categoryName).trim()); }
  },
  watch: { '$route.query.category': 'load' },
  mounted() { this.load(); },
  methods: {
    async resolveCategoryId() {
      if (this.isAnnouncementPage) return 22;
      if (!this.categoryName) return 0;
      try {
        const r = await this.$axios.get('/api/news/categories');
        const data = r.data && r.data.data;
        const categories = Array.isArray(data) ? data : [];
        const target = categories.find(item => String(item.name || '').trim() === this.categoryName);
        return target ? target.id : 0;
      } catch (e) {
        return this.isAnnouncementPage ? 22 : 0;
      }
    },
    async load() {
      this.loading = true;
      try {
        this.categoryId = await this.resolveCategoryId();
        const params = { limit: 20 };
        if (this.categoryId) params.category_id = this.categoryId;
        const r = await this.$axios.get('/api/news/list', { params });
        const data = r.data && r.data.data;
        const list = (data && data.data) || data || [];
        this.notices = Array.isArray(list) ? list : [];
      } catch (e) {
        this.notices = [];
      } finally {
        this.loading = false;
      }
    },
    openDetail(item) {
      this.$router.push({ name: 'newsDetail', query: { id: item.id, title: item.title, pageTitle: this.pageTitle } });
    },
    previewText(item) {
      const raw = item.desc || item.summary || item.content || '暂无资讯内容';
      const title = String(item.title || '').replace(/\s+/g, ' ').trim();
      let text = String(raw).replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
      if (title && text === title) return '';
      if (title && text.startsWith(title)) {
        text = text.slice(title.length).replace(/^[\s:：,，。\-—]+/, '').trim();
      }
      return text.length > 120 ? `${text.slice(0, 120)}...` : text;
    },
    formatTime(value) {
      if (!value) return '--';
      const date = new Date(String(value).replace(' ', 'T'));
      if (Number.isNaN(date.getTime())) return String(value).replace('T', ' ').replace(/\.\d+Z?$/, '').replace(/Z$/, '');
      const pad = n => String(n).padStart(2, '0');
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    }
  }
};
</script>
<style scoped>.notice-list-card{background:#fff;border-radius:18px;padding:20px;margin-bottom:16px;box-shadow:0 6px 18px rgba(75,52,0,.07)}.notice-list-card h2{font-size:20px;margin:0 0 14px;color:#211507}.notice-list-card p{color:#3a2a0f;line-height:1.9;white-space:pre-wrap;background:#fff8e8;border:1px solid #eee2c7;border-radius:12px;padding:12px;margin:0}.notice-list-card time{display:block;text-align:right;color:#8b806d;margin-top:18px;font-size:13px}</style>
